<template>
    <div>
        <div class="row form-group">
            <label class="col-md-2 control-label" for="payment_close_type">Payment at Close Type</label>
            <div class="col-md-3">
                <select class="form-control" name="payment_close_type" id="payment_close_type" @change="onChange($event)" v-model="selected">
                    <option disabled value="">--Please Select One--</option>
                    <option value="percent" >Percentage</option>
                    <option value="fixed">Fixed Amount</option>
                </select>
            </div>
            <modal-help>
                Select the payment type first and then enter the amount or percentage below.
            </modal-help>
        </div>
        <div class="row form-group">
            <label class="col-md-2 control-label" for="payment_close_value">{{ amountTitle }}</label>
            <modal-help>
                If payment type is percentage enter a number from 0 to 100.<br/>
                You can use 6 decimal places for percentage values e.g. 20.33333<br/>
                If payment type is fixed amount then enter a dollar value like 25.75.<br/>
                You can use two decimal places for dollar values.
            </modal-help>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon">{{ addOn }}</span>
                    <input type="text" class="form-control" name="payment_close_value" id="payment_close_value" v-model="inputAmount"/>
                </div>
            </div>
        </div>
      <div v-if="selected === 'percent' && userType === '1' && offeringType === '1'">
      <div class="row form-group">
        <label class="col-md-2 control-label" for="payment_close_value">Custom Close Payment</label>
        <span v-if="isVisible">{{ message }}</span>
        <div class="col-md-8">
          <label class="checkbox-inline">
          <input type="checkbox" name="custom_close_payment" id="custom_close_payment" v-model="modeData.custom_close_payment" @change="updatePaymentMode"/>
          Custom Close Payment
          </label>
          <modal-help>
            If you require a custom closing payment amount, check this box and then add your fee percentage and tax rate.
          </modal-help>
        </div>

      </div>
      <div v-if="modeData.custom_close_payment">
      <div class="row form-group" >
        <label class="col-md-2 control-label" for="fee_percent">Close Payment Fee (Percent)</label>
        <modal-help>
          This is the fee that you want to charge as a percentage of the closing payment.
        </modal-help>
        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">{{ addOn }}</span>
            <input type="text" class="form-control" name="fee_percent" id="fee_percent" v-model="postData.fee_percent"/>
          </div>
          <p>Please add your fee percentage.</p>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-md-2 control-label" for="tax_rate">Close Payment Tax (Percent)</label>
        <modal-help>
          This is the tax rate (GST,HST,PST) applicable to your province that you want to charge on the closing fee.
        </modal-help>
        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">{{ addOn }}</span>
            <input type="text" class="form-control" name="tax_rate" id="tax_rate" v-model="postData.tax_rate"/>
          </div>
          <p>Please add your tax rate.</p>
        </div>
      </div>
        <div class="row form-group">
          <label class="col-md-2 control-label" for="submit_payment">Submit Custom Payment</label>
          <div class="col-md-3">
            <div class="input-group">
              <button type="button" class="btn btn-default" name="submit_payment" id="submit_payment" @click="onClick">Save Custom Payment</button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
  import ModalHelp from "./ModalHelp";
  import axios from "axios";
	export default {
		components: {
      ModalHelp
    },
    props: [
        'userType',
        'paymentType',
        'paymentAmount',
        'customClosePayment',
        'offeringId',
        'paymentMode',
        'offeringType'
    ],
		data() {
			return {
				selected: this.paymentType ?? null,
        inputAmount: this.paymentAmount ?? '100.000000',
        title: 'Payment at Close',
        titlePercent: 'Percent',
        titleFixedAmount: 'Amount',
        amountTitle: '',
        postData: {
          payment_type: this.selected ?? this.paymentType,
          payment_amount: this.inputAmount ?? this.paymentAmount,
          offering_id: this.offeringId,
          fee_percent: this.customClosePayment.fee_percent ?? 0.00,
          tax_rate: this.customClosePayment.tax_rate ?? 0.00
        },
        modeData: {
          custom_close_payment: !!parseInt(this.paymentMode),
          offering_id: this.offeringId
        },
        message: '',
        isVisible: false
			}
		},
		computed: {
        addOn() {
          if(this.selected === 'percent') return '%';
          if(this.selected === 'fixed') return '$';
          if(this.selected === '') return '';
        }
    },
    methods: {
      newTitle() {
        this.amountTitle = this.title;
        if(this.selected === 'percent' || this.paymentType === 'percent') this.amountTitle =  this.title + ' ' + this.titlePercent;
        if(this.selected === 'fixed') this.amountTitle = this.title + ' ' + this.titleFixedAmount;
      },
			onChange(event) {
				this.selected = event.target.value;
        this.newTitle()
        },
      updateClosePayment() {
        axios.post('close_payment',this.postData)
            .then(response => {
              this.message = response.data.status
              this.isVisible = true
              this.timer()
              return Promise.resolve()
            })
      },
      updatePaymentMode() {
        axios.post('paymentMode',this.modeData)
            .then(response => {
              this.message = response.data.status
              this.isVisible = true
              this.timer()
              return Promise.resolve()
            })
      },
      onClick() {
        this.updateClosePayment()
      },
      timer() {
        setTimeout( () => {
          this.message = ''
          this.isVisible = false
        },3000)
      }
    },
    created() {
      this.newTitle()
    }
	}
</script>